
import { inject, shallowRef ,ref} from "vue";
export default {
    props:{
        region_fnc:{
            type:Function
        },
        site_show:{
            type:Boolean
        }
    },
  setup(props:any,{emit}:any) {
    const $http: any = inject("$http");
      let address:any = shallowRef([]);
      let english:any= shallowRef([])
      let active = ref<number>(-1)
      let tabs:any = shallowRef(['County'])
      let tabsActive =  ref<number>(0);
    let post_areas = async (id:string = '') => {
      let ret: any = await $http.post_areas({ parent_id: id , size: 100 });  
      if (ret.code === 200) {      
        address.value = ret.data
        let skt:any = []

        ret.data.forEach((e:any,index:number) => {
          skt.push(e.area_name.slice(0,1))
          
        });      
        address.value.sort((a:any, b:any) => a.area_name.charCodeAt(0) - b.area_name.charCodeAt(0)); //a~z 排序
         skt.sort((a:any, b:any) => a.charCodeAt(0) - b.charCodeAt(0)); //a~z 排序
        english.value = new Set(skt)
      }
    };
    post_areas();
    let k = 0 //保存选中状态
    let objs:any = {} //保存第一次选中的数据，没有点击的话就显示第一次的数据
    let firstobjs:any = []
    let region_fn = (i:number,obj:any)=>{       
          if(tabs.value.length<=1 || tabs.value[1] === 'Town' ){
                active.value = i
                objs = obj
                k = i
                post_areas(obj.area_id )
                  tabs.value = [obj.area_name,'Town']        
                if(tabs.value[1] === 'Town'){
                     active.value = -1  
                    console.log('objs',objs);
                                 
                }
                if( tabsActive.value === 1){     
                
                              
                //    emit('region_fnc',obj)
                //     post_areas();     
                }
              
               tabsActive.value = 1
               
          }           
    }
    let tabsItem = (item:string,index:number)=>{
          if(item !='Town'){
               post_areas(); 
          active.value = k         
          }else{
              post_areas(objs.area_id);
              active.value = -1
          }
          tabsActive.value = index
    }
    return {
        address,
        english,
        active,
        region_fn,
        tabs,
        tabsItem,
        tabsActive
    }
  },
};
